// Controls inside a property card keep their own behaviour: links, buttons,
// the gallery arrows, thumbnails and the fullscreen gallery.
const CARD_CONTROLS = [
  "a",
  "button",
  "input",
  "select",
  "textarea",
  "label",
  // Gallery slides are marked as buttons, but a click on a photo opens the property.
  "[role='button']:not(.image-gallery-slide)",
  ".image-gallery-icon",
  ".image-gallery-thumbnails-wrapper",
  ".image-gallery-bullets",
  ".image-gallery-content.fullscreen",
].join(", ");

// Whether a click on a property card should open the property.
export const opensPropertyFromCard = (event) => {
  if (event.defaultPrevented || event.button !== 0) return false;
  if (event.target?.closest?.(CARD_CONTROLS)) return false;
  if (document.fullscreenElement) return false;

  // Selecting text in the card is not a click on it.
  const selection = window.getSelection?.();

  return !(selection && !selection.isCollapsed && selection.toString().trim());
};
